import {
  Box,
  FormControl,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useCallback, useMemo, useState, useEffect } from "react";

const AccuracyClassSelector = ({
  toleranceClasses,
  onChange,
  defaultLabel = "Выберите класс точности",
  isSearchable = false,
  value = null,
}) => {
  const defaultClassLabel = useMemo(() => {
    return {
      label: defaultLabel,
      value: 0,
    };
  }, [defaultLabel]);

  const [accuracyClass, setAccuracyClass] = useState(defaultClassLabel);
  const accuracyClassValue = useMemo(() => value ?? accuracyClass, [value, accuracyClass]);

  useEffect(() => {
    setAccuracyClass(defaultClassLabel);
  }, [defaultClassLabel]);

  const toleranceClassesWithDefault = useMemo(() => {
    if (
      isSearchable ||
      (toleranceClasses.length > 0 &&
        toleranceClasses.some((x) => x.label === accuracyClassValue.label))
    ) {
      return toleranceClasses;
    }
    return [accuracyClassValue, ...toleranceClasses];
  }, [accuracyClassValue, isSearchable, toleranceClasses]);

  const toleranceClassItems = useMemo(() => {
    const accuracyClassItem = accuracyClassValue;

    const items = accuracyClassItem?.description?.split("\n");
    const itemsList = items?.map((v, i) => {
      if (v === "") return null;
      return (
        <ListItem key={i} sx={{ display: "list-item", p: "0px" }}>
          <ListItemText primary={v} />
        </ListItem>
      );
    });
    return itemsList?.every((x) => x !== null) ? itemsList : null;
  }, [accuracyClassValue]);

  const handleClassChange = useCallback(
    (e, newValue) => {
      const toleranceClass = isSearchable ? newValue : e.target.value;
      const validatedToleranceClass = toleranceClass ? toleranceClass : defaultClassLabel;
      setAccuracyClass(validatedToleranceClass);
      onChange && onChange(validatedToleranceClass);
    },
    [defaultClassLabel, isSearchable, onChange]
  );

  return (
    <>
      <FormControl fullWidth>
        {isSearchable ? (
          <Autocomplete
            options={toleranceClassesWithDefault}
            value={accuracyClassValue}
            onChange={handleClassChange}
            renderInput={(params) => <TextField {...params} />}
          />
        ) : (
          <Select
            value={accuracyClassValue}
            onChange={handleClassChange}
          >
            {toleranceClassesWithDefault.map((toleranceClass) => (
              <MenuItem key={toleranceClass?.label} value={toleranceClass}>
                {toleranceClass?.label}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>

      {toleranceClassItems && toleranceClassItems.length > 0 && (
        <Box sx={{ mb: 2, mx: 2 }}>
          <List sx={{ listStyleType: "disc" }}>{toleranceClassItems}</List>
        </Box>
      )}
    </>
  );
};

export default AccuracyClassSelector;
